export default __webpack_public_path__ + "static/media/Basketball.aa086fc3.svg";